export enum ToastDuration {
  SHORT = 2000,
  MEDIUM = 3000,
  LONG = 5000,
  VERY_LONG = 10000,
}

export const ToastIconType = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
} as const;
type TToastIconType = TValueOf<typeof ToastIconType>;

export interface IToastProps {
  id?: string;
  iconType?: TToastIconType;
  title?: string;
  message?: string;
  duration?: number;
  Content?: React.JSXElementConstructor<any>;
  onRequestClose?: () => any;
  hideCloseIcon?: boolean;
  //
  className?: string;
  contentClassName?: string;
}

export interface IToast {
  id: string;
  display: boolean;
  content: IToastProps;
}
